// extracted by mini-css-extract-plugin
export default {"input":"Input-module__input__1vUI4","invalid":"Input-module__invalid__vYn5e"};